import { Box, Button, Flex, Icon, useDisclosure } from "@chakra-ui/react";
import { useState } from "react";
import { FaSync } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import 'react-toastify/dist/ReactToastify.css';
import { Customer } from "utils/interfaces";
import CommunicationsTable from "./components/CommunicationsTable";
import NewCommunicationsModal from './Modal/NewCommunicationsModal';

export default function CustomerDetailCommunications({ customer }: { customer: Customer }) {

    const { isOpen, onOpen, onClose } = useDisclosure();
    const [handleFetchDeadlines, setHandleFetchDeadlines] = useState(true);

    return (
        <Flex flexDirection='column' overflowX={{ sm: 'scroll', lg: 'hidden' }}>
            <Box display="flex" justifyContent="flex-end" alignItems="center">
                <Button
                    _hover={{ bg: 'gray.700' }}
                    _active={{ bg: 'gray.600' }}
                    _focus={{ boxShadow: 'none' }}
                    backgroundColor='#688CC8'
                    color="white"
                    style={{
                        height: '30px',
                        padding: '0px 12px',
                        borderRadius: '6px',
                        border: 'none',
                        cursor: 'pointer',
                        marginLeft: 'auto'
                    }}
                    fontSize='s'
                    mx="1"
                    onClick={onOpen}
                    leftIcon={<MdEmail />}
                >
                    Nuova
                </Button>
                <Button
                    onClick={() => setHandleFetchDeadlines(true)}
                    variant="ghost"
                    colorScheme="blue"
                    mx="1"
                    p={2}
                    _hover={{ bg: 'gray.200' }}
                >
                    <Icon as={FaSync} w={5} h={5} />
                </Button>
            </Box>
            <Box>
                <CommunicationsTable
                    customer={customer}
                    isOpen={isOpen}
                    handleFetchDeadlines={handleFetchDeadlines}
                    setHandleFetchDeadlines={setHandleFetchDeadlines}
                />
            </Box>

            {/* Modal used to create new communications */}
            <NewCommunicationsModal
                isOpen={isOpen}
                onClose={onClose}
                customer={customer}
            />
        </Flex>
    );
}